import React from 'react'
import { ClipLoader } from '@lua-frontend/numu-ui'

export const InputFieldLoader = ({ isLoading }) => {
  return (
    <div style={{ position: 'absolute', top: 7, right: 27 }}>
      <ClipLoader size={20} loading={isLoading} />
    </div>
  )
}
